export default __webpack_public_path__ + "static/media/bonusnote.b7961c97.png";